import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from "@/router";
import pinia from './store/index'
import 'bootstrap/dist/css/bootstrap.css'
import MyButton from '@/components/MyButton'
const app = createApp(App)

app.use(router)
app.use(ElementPlus)
app.use(MyButton)
app.use(pinia)
app.mount('#app')
